{
  "skipToContent": "Skip to content",
  "themeSwitcher": "Choose a theme",
  "langSwitcher": "Change language",
  "motionToggle": "Reduce motion",
  "routeAnnounce": "Navigated to {{page}}",
  "openMenu": "Open menu",
  "closeMenu": "Close menu",
  "externalLink": "opens in a new tab",
  "loading": "Loading, please wait",
  "loaded": "Content loaded",
  "dialog": {
    "close": "Close dialog",
    "title": "Dialog"
  },
  "carousel": {
    "label": "Carousel",
    "next": "Next slide",
    "previous": "Previous slide",
    "slide": "Slide {{current, number}} of {{total, number}}"
  },
  "progress": "{{percent, number}} percent complete",
  "sortAscending": "Sorted ascending",
  "sortDescending": "Sorted descending",
  "required": "Required",
  "invalid": "Invalid value",
  "newTabWarning": "Link opens in a new tab",
  "commandPalette": "Command palette. Type to search, arrow keys to move, Enter to select.",
  "searchResults": "Search results",
  "terminal": "Interactive terminal",
  "terminalOutput": "Terminal output",
  "terminalInput": "Terminal command",
  "connection": "Connection status"
}
